import React from "react";
import AuthForm from "./lib/AuthForm";
import AuthFlowBase from "./lib/AuthFlowBase";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import withAuthAdapter from "../lib/withAuthAdapter";

// import createAuthSpinHandler from './lib/createAuthSpinHandler';

class SignInForm extends AuthForm {
  get components() {
    return [
      {
        id: "email",
        label: "Email",
        component: <input ref="autoFocus" type="text" />,
      },
      {
        id: "password",
        label: "Password",
        component: <input type="password" />,
      },
      {
        id: "submit",
        component: <button type="submit">Sign In</button>,
      },
    ];
  }
}

class SignIn extends AuthFlowBase {
  handleSignIn(state) {
    this.clearValidationErrors();
    this.props.authAdapterFactory.authAdapter
      .signIn({
        email: state.email,
        password: state.password,
      })
      .then((signInUserSession) => {
        console.log("login success", signInUserSession.accessToken);
        // console.log('login success', accessToken, idToken, refreshToken);
        // console.log('access token + ' + result.getAccessToken().getJwtToken());
        // the cognitoUser.authenticateUser method already caches this to localStorage so we're done
        this.props.emitMetricEvent("auth", "sign-in");
        this.onSuccess();
        this.onSignIn();
      })
      .catch(this.handleValidationError.bind(this));
  }

  render() {
    return (
      <div>
        <ul>
          <li>
            Don't have an account? Go <Link to="/users/sign-up">Sign up</Link>
          </li>
          <li>
            Can't remember your password? Go to our{" "}
            <Link to="/users/forgot-password">Forgot/Reset Password</Link> page
          </li>
          <li>
            <strong>note:</strong> Headless-Render-API.com{" "}
            <em>was previously known</em> as Prerender.cloud (rebranded
            2022-05-01)
          </li>
        </ul>
        <br />
        <SignInForm
          {...this.props}
          {...this.baseProps}
          onSubmit={this.handleSignIn.bind(this)}
        />
      </div>
    );
  }
}

export default withAuthAdapter(withRouter(SignIn));



// WEBPACK FOOTER //
// ./src/auth/SignIn.js